import { createSlice } from "@reduxjs/toolkit";
import {
  showRoleItems,
  IsPermisionPathRequired,
  IsPermisionOidRequired,
} from "../actions";

const initialState = {
  middleware: [],
  middlewarePath: [],
  loading: false,
};

const middlewareSlice = createSlice({
  name: "middleware",
  initialState,
  reducers: {},
  extraReducers: {
    [showRoleItems.fulfilled]: (state, action) => {
      state.middleware = action.payload || [];
    },
    [IsPermisionPathRequired.pending]: (state, action) => {
      state.loading = true;
    },
    [IsPermisionPathRequired.fulfilled]: (state, action) => {
      state.loading = false;
      state.middlewarePath = action.payload || [];
    },
    [IsPermisionOidRequired.pending]: (state, action) => {
      state.loading = true;
      state.middleware = action.payload || [];
    },
    [IsPermisionOidRequired.fulfilled]: (state, action) => {
      state.loading = false;
      state.middleware = action.payload || [];
    },
  },
});

export const responseMiddleware = (state) => state.middleware;

export default middlewareSlice.reducer;
